import { Property } from 'up-ibe-types';

export const sortPropertiesByName = (a: Property, b: Property): number => {
    return (a.name).localeCompare(b.name);
};
